import React, {useState} from "react";
import {DatePicker, Checkbox, Select, Tooltip} from "antd";
import moment from "moment";
import styled from "styled-components";
import {VFlex} from "../Flex/VFlex";
import {useFetch} from "hooks/useFetch";
import {useStore} from "hooks/useStore";
import {InfoCircleOutlined} from "@ant-design/icons";

const StyledCheckbox = styled(Checkbox)`
    &.ant-checkbox-wrapper {
        display: flex;
        align-items: center;
        &:hover h5 {
            text-decoration: none !important;
            border-bottom: none !important;
        }
    }
`;

const DateRangeOrPeriodFilterWithCheckbox = ({
    dateRangeChecked = true, // Default olarak tarih seçili
    periodChecked = false,
    onDateRangeCheckChange,
    onPeriodCheckChange,
    dateRangeValue,
    onDateRangeChange,
    periodValue,
    onPeriodChange,
    dateRangePlaceholder = ["Başlangıç Tarihi", "Bitiş Tarihi"],
    periodPlaceholder = "Dönem Seçiniz",
    dateRangeFormat = "YYYY-MM-DD",
    disabled = false,
    paymentPeriods
}) => {
    const MAX_RANGE_DAYS = 32;
    const [rangePickerDates, setRangePickerDates] = useState(null);
    const [dateRangeError, setDateRangeError] = useState(null);

    const disabledDate = current => {
        if (!rangePickerDates || !rangePickerDates[0]) return false;
        const start = rangePickerDates[0];
        return (
            current.diff(start, "days") > MAX_RANGE_DAYS - 1 ||
            start.diff(current, "days") > MAX_RANGE_DAYS - 1
        );
    };

    const onCalendarChange = dates => {
        setRangePickerDates(dates);
    };

    const onOpenChange = open => {
        if (!open) setRangePickerDates(null);
    };

    const handleDateRangeCheckboxChange = e => {
        const isChecked = e.target.checked;
        setDateRangeError(null);
        if (isChecked) {
            onPeriodCheckChange(false);
            onPeriodChange(null);
            onDateRangeCheckChange(true);
        } else {
            onDateRangeChange(null);
            onDateRangeCheckChange(false);
            onPeriodCheckChange(true);
        }
    };

    const handlePeriodCheckboxChange = e => {
        const isChecked = e.target.checked;
        if (isChecked) {
            onDateRangeCheckChange(false);
            // Tarihleri temizleme, dönem seçildiğinde temizlenecek
            onPeriodCheckChange(true);
        } else {
            onPeriodChange(null);
            onPeriodCheckChange(false);
            onDateRangeCheckChange(true);
        }
    };

    return (
        <VFlex vertical gap={4}>
            <VFlex align="center" gap={16} style={{minHeight: 22}}>
                <StyledCheckbox
                    checked={dateRangeChecked}
                    onChange={handleDateRangeCheckboxChange}
                    disabled={disabled}
                >
                    <VFlex align="flex-start" gap={4}>
                        <h5>Başlangıç - Bitiş Tarihi</h5>
                        <Tooltip title="Tarih aralığı 32 günden fazla olamaz">
                            <InfoCircleOutlined
                                style={{color: "#000", fontSize: "12px", marginTop: "2px"}}
                            />
                        </Tooltip>
                    </VFlex>
                </StyledCheckbox>
                <StyledCheckbox
                    checked={periodChecked}
                    onChange={handlePeriodCheckboxChange}
                    disabled={disabled}
                >
                    <h5>Dönem</h5>
                </StyledCheckbox>
            </VFlex>
            <VFlex style={{minHeight: 32, minWidth: 300}} vertical>
                {(dateRangeChecked || (!dateRangeChecked && !periodChecked)) && (
                    <>
                        <DatePicker.RangePicker
                            value={
                                dateRangeValue && dateRangeValue[0] && dateRangeValue[1]
                                    ? [
                                          moment.isMoment(dateRangeValue[0])
                                              ? dateRangeValue[0]
                                              : moment(dateRangeValue[0]),
                                          moment.isMoment(dateRangeValue[1])
                                              ? dateRangeValue[1]
                                              : moment(dateRangeValue[1])
                                      ]
                                    : null
                            }
                            disabledDate={disabledDate}
                            onCalendarChange={onCalendarChange}
                            onOpenChange={onOpenChange}
                            onChange={dates => {
                                if (dates && dates[0] && dates[1]) {
                                    const diffDays = dates[1].diff(dates[0], "days");
                                    if (diffDays > MAX_RANGE_DAYS - 1) {
                                        setDateRangeError(
                                            `Tarih aralığı ${MAX_RANGE_DAYS} günden fazla olamaz`
                                        );
                                        return;
                                    }
                                    setDateRangeError(null);
                                    onDateRangeChange(dates);
                                } else {
                                    setDateRangeError(null);
                                    onDateRangeChange(null);
                                }
                            }}
                            format={dateRangeFormat}
                            placeholder={dateRangePlaceholder}
                            disabled={disabled}
                            style={{minWidth: 300}}
                            status={dateRangeError ? "error" : undefined}
                        />
                        {dateRangeError && (
                            <span style={{color: "#e74c3c", fontSize: 12, marginTop: 4}}>
                                {dateRangeError}
                            </span>
                        )}
                    </>
                )}
                {periodChecked && (
                    <Select
                        value={periodValue}
                        onChange={onPeriodChange}
                        placeholder={periodPlaceholder}
                        disabled={disabled}
                        style={{minWidth: 300, width: "100%"}}
                        options={paymentPeriods.result?.map(period => ({
                            label: period?.name,
                            value: period?._id
                        }))}
                    />
                )}
            </VFlex>
        </VFlex>
    );
};

export default DateRangeOrPeriodFilterWithCheckbox;
